export default {
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    async clipboardCopy(text) {
      await navigator.clipboard.writeText(text);
      this.$customAlert({
        type: 'success',
        msg: 'Sucesso'
      });
    },
    loggedUser() {
      if (!this.$store.state?.session?.user) {
        return {};
      }
      if (typeof this?.$store?.state?.session?.user === 'string') {
        return JSON.parse(this.$store.state.session.user);
      }
      return this.$store.state.session.user;
    },
    getCompanySettingsFromLocalStorage() {
      const user = this.loggedUser();
      if (!user || !user.company || !user.company.id) {
        return null;
      }

      const companyId = user.company.id;
      const cached = localStorage.getItem(`company_${companyId}_settings`);

      if (cached) {
        try {
          return JSON.parse(cached);
        } catch (err) {
          console.error('Erro ao parsear configurações do localStorage:', err);
          localStorage.removeItem(`company_${companyId}_settings`);
        }
      }

      return null;
    },
    shouldHideCpa() {
      this.$store.state.companySettings;
      return this.$utils.checkOcultarCpa();
    }
  },
  watch: {}
};
